export const BASE_URL_SERVER =
  'https://c9guzla9di.execute-api.us-east-2.amazonaws.com/dev';

// export const BASE_URL_SERVER = 'http://localhost:3000/dev';

export const WEBSOCKET_URL =
  'https://9fr4nizii0.execute-api.us-east-2.amazonaws.com/dev';

export const AUTH_URL = {
  // localhost: 'https://h03l569p11.execute-api.us-east-2.amazonaws.com/localhost',

  localhost: 'http://localhost:3000/dev',

  'dating.date':
    'https://sm6xcy952c.execute-api.us-east-2.amazonaws.com/dating-date',
  'datingcom.uk':
    'https://l2iwamspy4.execute-api.us-east-2.amazonaws.com/datingcom-uk',
  'datingclassifiedads.com':
    'https://ujmkuwyrei.execute-api.us-east-2.amazonaws.com/datingclassifiedads',
  'dreamonelove.com':
    'https://gvzdy58gc8.execute-api.us-east-2.amazonaws.com/dreamonelove',
};

export const ADMINS = ['6707ff6685993a06a42027af'];
export const MANAGERS = ['678fc7641b623fea3cdf9d24'];

const ONE_MINUTE = 1000 * 60;
export const CHAT_SESSION = ONE_MINUTE * 10;
export const VIDEO_SESSION = ONE_MINUTE * 10;
export const VOICE_SESSION = ONE_MINUTE * 10;
